export default __webpack_public_path__ + "static/media/384.d3b0e5b8.jpg";